import React, { ReactElement } from 'react';
import Image from './Image';
import Span from './Span';
import { styled } from '@mui/material';

export type Props = {
  children: string,
  logoSource: string | null,
  placeholder?: ReactElement,
  sizeV: number,
  sizeH?: number | string,
  fontWeight?: string | number,
  fontSize?: string | number,
  logoSizeH: number,
  minWidth?: string,
};

const Box: any = styled('div')<Props>(({ sizeV, sizeH, fontWeight, fontSize, minWidth }) => ({
  boxSizing: 'content-box',
  whiteSpace: 'nowrap',
  border: '1px solid #DFE1E6',
  borderRadius: '6px',
  overflow: 'hidden',
  background: '#ffffff',
  color: '#091E42',
  height: sizeV,
  maxWidth: '100%',
  ...(minWidth ? { minWidth } : {}),
  ...(sizeH ? { width: sizeH } : {}),
  ...(fontWeight ? { fontWeight } : {}),
    ...(fontSize ? { fontSize } : {}),
}));

const LogoBox: any = styled('div')<Props>(({ logoSizeH }) => ({
  display: 'inline-block',
  width: logoSizeH,
  verticalAlign: 'middle',
}));

const TitleBox: any = styled('div')<Props>(({ sizeV, logoSizeH }) => ({
  display: 'inline-block',
  boxSizing: 'border-box',
  height: sizeV,
  lineHeight: `${sizeV}px`,
  verticalAlign: 'middle',
  width: `calc(100% - ${logoSizeH}px)`,
  textAlign: 'left',
  padding: '0 12px',
  borderLeft: '1px solid #DFE1E6',
}));

export default (props: Props) => (
  <Box {...props}>
    <LogoBox {...props}>
      <Image
        sizeV={props.sizeV}
        sizeH={71}
        source={props.logoSource}
        placeholder={props.placeholder}
        color='#C1C7D0'
      />
    </LogoBox>
    <TitleBox {...props}>
      <Span>{props.children}</Span>
    </TitleBox>
  </Box>
);
